const createDocumentTitleRegistry = (productName) => {
  const fragments = /* @__PURE__ */ new Map();
  let lastPosition = 0;
  const updateDocumentTitle = () => {
    const titles = [...fragments.values()].sort((fragment1, fragment2) => fragment1.position - fragment2.position).map(({ title }) => title).filter((title) => title.trim() !== "");
    document.title = [productName, ...titles].join(" - ");
  };
  return {
    reservePosition: () => {
      lastPosition += 1;
      return lastPosition;
    },
    register: (title, position) => {
      const id = Symbol("document-title");
      fragments.set(id, { position, title });
      updateDocumentTitle();
      return () => {
        fragments.delete(id);
        updateDocumentTitle();
      };
    }
  };
};
export default createDocumentTitleRegistry;
